import { UserId, UserProfile } from '@beelday/common'
import { useMemo } from 'react'
import { KnowledgeCheckStats } from './knowledge-check'
import {
	groupParticipants,
	ParticipantOverview,
} from './model/participant-groups'
import useParticipantProfiles from './use-participant-profiles'

/** What the participants panel shows: who is where, and their faces. */
const useParticipantOverview = (
	stats: KnowledgeCheckStats
): { overview: ParticipantOverview; profiles: Record<UserId, UserProfile> } => {
	const overview = useMemo(() => groupParticipants(stats), [stats])
	const userIds = useMemo(
		() => overview.groups.flatMap(group => group.userIds),
		[overview]
	)
	const profiles = useParticipantProfiles(userIds)
	return { overview, profiles }
}

export default useParticipantOverview
